import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const AboutUs = (settings) => {
    const [metaData, setMetaData] = useState({});

    useEffect(() => {
        if (settings.setting && settings.setting.length > 0) {
            const meta = {};
            settings.setting.forEach((setting) => {
                if (setting.type === "facebook_link") meta.facebook_link = setting.value;
                if (setting.type === "twitter_link") meta.twitter_link = setting.value;
                if (setting.type === "instagram_link") meta.instagram_link = setting.value;
                if (setting.type === "linkedin_link") meta.linkedin_link = setting.value;
            });
            setMetaData(meta);
        }
    }, [settings]);

    return (
        <>
            <Helmet>
                <title>About Us | Elly Decor</title>
                <meta name="title" content="About Us | Elly Decor" />
                <meta
                    name="description"
                    content="Discover Elly Decor – your destination for premium Bedding, Curtains, Wallpaper, Blinds, Mats, Table Linen, and Bath Linen. Style and comfort for every space."
                />
            </Helmet>

            <section className="about-page-title" style={{ backgroundImage: `url('/images/about-us.png')` }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="title">ABOUT US</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-us pt-0 pt-lg-4">
                <div className="container">
                    {/* Section 2 */}
                    <div className="row align-items-center mb-3 mt-2">
                        <div className="col-lg-6">
                            <img
                                src="/images/about.png"
                                alt="Curtain Fabrics"
                                className="img-fluid rounded"
                            />
                        </div>
                        <div className="col-lg-6">
                            <p className='mb-2 mt-3 mt-lg-0 mt-lg-3  mb-lg-3'>Best Selling Finishes</p>
                            <h2 className="fw-bold mb-3 text-theme-dark responsive-main-heading">
                                Bringing Your Dream Interior Design to Life
                            </h2>
                            <p className="mb-3 mb-lg-4 text-theme-dark">
                                Simple and balanced. Alexander Petillo brings together flavors and
                                specialties, Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation ullamco.
                            </p>
                            <a href="#" className="heroLink">
                                Enquiry Now
                            </a>
                        </div>

                        {/* Stats Row */}
                        <div className="row text-center mt-2">
                            <div className="col-md-3 col-6 mb-1">
                                <h2 className="fw-bold text-theme-dark colOutline">25+</h2>
                                <p className="mb-0 text-dark abSpeed">Interior Design</p>
                            </div>
                            <div className="col-md-3 col-6 mb-1">
                                <h2 className="fw-bold text-theme-dark colOutline">93+</h2>
                                <p className="mb-0 text-dark abSpeed">Architecture</p>
                            </div>
                            <div className="col-md-3 col-6 mb-1">
                                <h2 className="fw-bold text-theme-dark colOutline">48+</h2>
                                <p className="mb-0 text-dark abSpeed">Construction</p>
                            </div>
                            <div className="col-md-3 col-6 mb-1">
                                <h2 className="fw-bold text-theme-dark colOutline">68+</h2>
                                <p className="mb-0 text-dark abSpeed">Projects Done</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="hero-section2">
                <div className="container-fluid px-5">
                    <div className="row">
                        <div className="col box noMask">
                            <h6 className='h1Work text-center'>YOUR BEST CHOICE</h6>
                            <p className='h1Heading2 text-center'>Let's start your new dream project</p>
                            <a href='#' className='heroLink text-center'>Get A Quote</a>
                        </div>

                    </div>
                </div>
            </section>

            <section className="visit-shop py-3 py-lg-5">
                <div className="container">
                    <div className="text-center mb-3 mb-lg-5">
                        <h2 className="fw-bold responsive-main-heading">Visit Our Shop</h2>
                        <p className="text-muted text-start text-lg-center mb-0">
                            Explore our wide collection of premium curtain fabrics, designed to add elegance and comfort to your home interiors.
                            Whether you’re looking for modern, classic, or custom styles – we have something for everyone.
                        </p>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-3">
                            <img
                                src="/images/product/prd2.webp"
                                alt="Curtain Fabrics"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <img
                                src="/images/product/prd2.webp"
                                alt="Curtain Fabrics"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default AboutUs;
